export const stringsKey = "FailureActionConfiguration";
export const englishStrings = {
	failureActionTypeLabel: "Select Failure Action Type",
	failureDefaultValueLabel: "Failure Default Value",
	failureMessageTextLabel: "Failure Message Text",
	failureAudioFileLabel: "Failure Audio File",
	failureActionTypeErrorMessage: "The failure action type field is required.",
	failureDefaultValueErrorMessage:
		"The failure default value field is required.",
	failureMessageTextErrorMessage: "The failure message text field is required.",
};
